module.exports = __webpack_public_path__ + "static/media/square.a953efb6.png";